import React, {Fragment} from "react";
import useListboxFetch from "root/ReactHookForm/ui/useListboxFetch";
import SpinnerDiv from "ui/ReactSpinnerDiv";
import {CommonDropdown} from "root/s360components/ReactHookForm/ui/CommonDropdown";

//The LEA every legacy screen defaulted to before an LEA could be chosen
export const DEFAULT_LEA = { value: 1, label: 'Northumberland' };

const DropdownLeas = ({setLeaDetails, control, name, rules, placeholder, isSearchable, isClearable, readOnly}) =>
{
    const onChange = (data) =>
    {
        if ( setLeaDetails !== undefined )
        {
            setLeaDetails({lea_id: data.value , lea_name: data.label})
        }
    }

    const fields = { url: '/school360/leas', keyFieldName: 'lea_id', labelFieldName: 'lea_name' }

    const [ loading, items ] = useListboxFetch( fields ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} name={name} rules={rules}
                                                   onChange={onChange} readOnly={readOnly}
                                                   isSearchable={isSearchable} isClearable={isClearable}
                                                   placeholder={placeholder === undefined ? DEFAULT_LEA.label : placeholder} /> }
        </Fragment>
    )
}

export default DropdownLeas;
